import { Controller } from '@hotwired/stimulus';
import confetti from 'canvas-confetti';

export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.shootConfetti();
    }, 500);
  }

  shootConfetti() {
    confetti({
      angle: 90,
      spread: 100,
      particleCount: 72,
      origin: { y: 0.45 }
    });
  }
}
